document.addEventListener("DOMContentLoaded", function () {

    // PRODUCT PAGE RECOMMENDATION REPOSITION
    if (window.innerWidth >= 768 && document.querySelector('.template-product')) {
        const recommendations = document.querySelector('.product-recommendations');
        const productText = document.querySelector('.product-text');

        if (recommendations && productText) {
            productText.appendChild(recommendations);
        }
    }

    // PRODUCT PAGE TOGGLES REPOSITION
    if (window.innerWidth >= 768 && document.querySelector('.template-product')) {
        const toggles = document.querySelectorAll('.product-text .toggle');
        const productGallery = document.querySelector('.product-gallery');

        if (toggles.length && productGallery) {
            toggles.forEach(toggle => {
            productGallery.appendChild(toggle);
            });
        }
    }

    // PRODUCT PAGE STICKY ATC
    if (window.innerWidth <= 767 && document.querySelector('.template-product')) {
        const productActions = document.querySelector('.product-actions');
        const sentinel = document.querySelector('.product-actions-sentinel');
        

        const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) {
            productActions.classList.add('is-sticky');
            const chatButton = document.querySelector('#chat-button');
            chatButton.classList.add('move-up');
            } else {
            productActions.classList.remove('is-sticky');
            const chatButton = document.querySelector('#chat-button');
            chatButton.classList.remove('move-up');
            }
        },
        {
            root: null,
            threshold: 0
        }
        );

        if (sentinel) {
        observer.observe(sentinel);
        }
    }
    // NOTIFY ME BTN HIGHLIGHT
    if (window.location.hash === "#klaviyo-bis-trigger") {
      const maxWait = 5000;
      const pollInterval = 200;
      let waited = 0;

      const interval = setInterval(function () {
        const bisButton = document.querySelector('.klaviyo-bis-trigger');
        if (bisButton) {
          clearInterval(interval);

          bisButton.scrollIntoView({ behavior: 'smooth', block: 'center' });

          bisButton.style.transition = 'box-shadow 0.6s ease-in-out';
          
          let glow = true;
          const pulse = setInterval(() => {
            bisButton.style.boxShadow = glow
              ? '0 0 12px 4px rgb(44,171,211)'
              : '0 0 4px 1px rgba(255, 193, 7, 0.2)';
            glow = !glow;
          }, 1000);

          bisButton.addEventListener('click', function () {
            clearInterval(pulse);
            bisButton.style.boxShadow = 'none';
          });
        }

        waited += pollInterval;
        if (waited >= maxWait) clearInterval(interval);
      }, pollInterval);
    }

    const galleryList = document.querySelector('.product-gallery');

    // HAMPER INITIAL DISPLAY 
    let letterDisplay = null;
    if (galleryList) {
        letterDisplay = document.createElement('div');
        letterDisplay.className = 'select-letter-display';
        letterDisplay.style.cssText = `
        position: absolute;
        z-index: 999;
        left: 50%;
        top: 0%;
        transform: translateX(-50%);
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        `;
        galleryList.appendChild(letterDisplay);
    }

    function removeWhiteBackground(imageUrl, callback) {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = function() {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
            if (data[i] > 240 && data[i+1] > 240 && data[i+2] > 240) {
            data[i+3] = 0;
            }
        }

        ctx.putImageData(imageData, 0, 0);
        callback(canvas.toDataURL());
        };
        img.src = imageUrl;
    }

    document.addEventListener("click", function(e) {
        const label = e.target.closest('.gs__product-option[data-child-name="select-letter"] .gs__option-upsell-label');
        if (!label || !letterDisplay) return;

        if (label.dataset.handled) return;
        label.dataset.handled = "true";
        setTimeout(() => delete label.dataset.handled, 0);

        const bgImage = getComputedStyle(label).backgroundImage;
        const match = bgImage.match(/url\(["']?(.*?)["']?\)/);
        const imageUrl = match ? match[1] : null;
        if (!imageUrl) return;

        const isMobile = window.innerWidth <= 768;
        const imgSize = isMobile ? 100 : 150;

        const existingImg = Array.from(letterDisplay.children).find(img => img.dataset.src === imageUrl);

        if (existingImg) {
        letterDisplay.removeChild(existingImg);
        } else {
        removeWhiteBackground(imageUrl, function(newUrl) {
            const img = document.createElement('img');
            img.src = newUrl;
            img.dataset.src = imageUrl;
            img.style.width = imgSize + 'px';
            img.style.height = imgSize + 'px';
            img.style.margin = '0 -15px';
            img.style.objectFit = 'contain';
            letterDisplay.appendChild(img);
        });
        }
    });

    window.addEventListener("resize", function() {
        const isMobile = window.innerWidth <= 768;
        const imgSize = isMobile ? 100 : 150;
        if (letterDisplay) {
        Array.from(letterDisplay.children).forEach(img => {
            img.style.width = imgSize + 'px';
            img.style.height = imgSize + 'px';
        });
        }
    });
});
// COUNTRY SELECTER
document.getElementById('country-aus').addEventListener('click', function(event) {
    document.getElementById('country-aus').classList.add("selected");
    document.getElementById('country-uae').classList.remove("selected");
    document.getElementById('state-selector').classList.add("show");
    document.getElementById('state-selector-text').classList.add("show");
    document.querySelector('.js-state-selector').classList.add("show");
});

document.getElementById('state-selector').addEventListener("click", function () {
  document.querySelector('.js-state-selector').classList.add("active");
});
// END COUNTRY SELECTER

// ADD SUFFIX ON SELECTED STATE
document.addEventListener('DOMContentLoaded', function () {
  var stateDataEl = document.querySelector('[data-state-selected]');
  var selectedState = stateDataEl ? stateDataEl.getAttribute('data-state-selected') : null;
  var selectedCountry = document.documentElement.dataset.countrySelected;
  
  if (selectedState && selectedCountry != "AE") {
    var dropdown = document.getElementById('state-selector');
    var options = dropdown.options;

    for (var i = 0; i < options.length; i++) {
      if (options[i].value === selectedState) {
        if (!options[i].text.includes('- Current')) {
          options[i].text = options[i].text + ' - Current';
        }
        break;
      }
    }
  }
});
// END ADD SUFFIX ON SELECTED STATE

const domReady = () => {
    contentBasedOnSelectedState();
    initStateSelector();
    okendoReviewsHideZeroReviews();

    document.addEventListener('recentlyViewed:loaded', okendoReviewsHideZeroReviews);
}

const initStateSelector = () => {
    const containers = document.querySelectorAll('.js-site-state-selector-handle');
    const selectedCountry = document.documentElement.dataset.countrySelected;

    if (containers.length) {

        containers.forEach(container => {
            const selectedState = document.documentElement.dataset.stateSelected;
            const label = container.querySelector('[data-store-label]');

            if (label && selectedState && selectedCountry != "AE") {
                label.innerHTML = selectedState.toUpperCase();
            } else if (selectedCountry == "AE") {
                label.innerHTML = selectedCountry.toUpperCase();
            }

            container.addEventListener('click', (e) => {
                console.log({ e });
                if (document.getElementById(e.target.getAttribute('aria-controls'))) {
                    document.getElementById(e.target.getAttribute('aria-controls')).show();
                }
            })
        });
    }

    const selectedState = document.documentElement.dataset.stateSelected;
    if (selectedState) {
        const stateSelector = document.getElementById('state-selector');
        if (stateSelector) stateSelector.value = selectedState;
    }
}

const contentBasedOnSelectedState = () => {
    // Content based on selected state
    // Reads off root element <html> attribute data-selected-state and uses CSS to hide/show content
    const selectedState = document.documentElement.dataset.stateSelected;
    const items = document.querySelectorAll('[data-state]');
    const sections = ['site-nav', 'slideshow', 'text-columns-icons', 'featured-collection', 'delivery-information'];

    if (selectedState) {
        const groupBySection = [...items].reduce((acc, el) => {
            const key = sections.find((s) => [...el.classList].includes(s));
            const curGroup = acc[key] ?? [];
            return { ...acc, [key]: [...curGroup, el] };
        }, {});

        for (const arr of Object.values(groupBySection)) {
            const hasSelectedState = arr.filter((el) => el.dataset.state === selectedState);

            if (hasSelectedState.length) {
                arr.forEach((el) => el.classList.remove('is-visible'));
                hasSelectedState.forEach((el) => el.classList.add('is-visible'));
            } else {
                arr
                    .filter((el) => el.dataset.state === 'DEFAULT') // DEFAULT = Non-VIC
                    .forEach((el) => el.classList.add('is-visible'))
            }
        }
    } else {
        [...items]
            .filter((el) => el.dataset.state === 'DEFAULT')
            .forEach((el) => el.classList.add('is-visible'));
    }

    document.dispatchEvent(new CustomEvent('stateBasedContent:loaded'));
}

document.addEventListener('DOMContentLoaded', domReady);

// START GLOBAL AJAX ADD TO CART FUNCTIONS

// add multiple products to cart
const addProductsToCart = (arr = []) => {
    // Example: arr = [{id: '1234', quantity: 1, properties: {}}, {id: '2345', quantity: 2}]
    if (arr.length === 0) return;

    let items = arr;

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items },
        dataType: 'json',
        success: function () {
            // update cart
            window.refreshCart()

            document.dispatchEvent(new CustomEvent('cart:refreshed'));
        }
    });
}

// add single product to cart
const addProductToCart = (variant_id = '', qty = 0, properties = null) => {
    if (!variant_id || variant_id == '' || qty === 0) return;

    let data = {
        "id": variant_id,
        "quantity": qty
    }

    if (properties) {
        data["properties"] = properties;
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
            // update cart
            window.refreshCart();

            document.dispatchEvent(new CustomEvent('cart:refreshed'));
        }
    });
}

// Remove item from cart
const removeItemFromCart = (key) => {
    if (!key) return;

    let updates = {}
    updates[key] = 0;

    jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { updates },
        dataType: 'json',
        success: function (res) {
            // update cart
            window.refreshCart();

            document.dispatchEvent(new CustomEvent('cart:refreshed'));
        }
    });
}
// END GLOBAL AJAX ADD TO CART FUNCTIONS

window.addEventListener('DOMContentLoaded', () => {
    // SWYM WISHLIST ATC
    // $(document).on('click', '.swym-close-btn', () => {
    //     setTimeout(() => {
    //         window.refreshCart();
    //     }, 1000);
    // })

    // CART RECOMMENDATIONS SLIDER
    $(document).on('click', '.recommendations-slide__atc-btn', (e) => {
        const btn = e.currentTarget;
        const id = btn.getAttribute('data-id');
        const qty = btn.closest(".product-item").querySelector(".cart-recommendations-item-quantity").value;

        if (!id || id == '') return;

        addProductToCart(id, qty);
    })

    // CART FREE GIFT SLIDER
    $(document).on('click', '.cart-free-gift-slide__atc-btn', (e) => {
        const btn = e.currentTarget;
        const id = btn.getAttribute('data-id');

        if (!id || id == '') return;

        addProductToCart(id, 1, { "_freeGift": true });
    })

    document.addEventListener('cart:refreshed', async (e) => {
        let cartContents = await fetch('/cart.js')
            .then(response => response.json())
            .then(data => { return data });

        // cartContents.items.forEach(item => {
        //     if (item.properties?.["_freeGift"] && item.final_price > 0) {
        //         removeItemFromCart(item.key);
        //     }
        // });
    })

    // SAME DAY DISPATCH TIMER
    const dispatch_countdown_sections = document.querySelectorAll('.cart-dispatch-timer');
    const initSameDayDispatchTimer = (elem) => {
        console.log({ elem })
        // ELEMENTS
        const dispatchTimer_hours = elem.querySelector('[data-timer-hours]');
        const dispatchTimer_mins = elem.querySelector('[data-timer-minutes]');
        const dispatchTimer_secs = elem.querySelector('[data-timer-seconds]');

        // CURRENT TIME
        const m = dayjs().get('month') + 1;
        const d = dayjs().get('date');

        const currYear = dayjs().get('year');
        const currMonth = m < 10 ? '0' + m : m;
        const currDay = d < 10 ? '0' + d : d;

        // CHECK DEADLINE
        let d_h = parseInt(elem.getAttribute('data-h'));
        d_h = d_h < 10 ? '0' + d_h : d_h;
        let d_m = parseInt(elem.getAttribute('data-m'));
        d_m = d_m < 10 ? '0' + d_m : d_m;
        let d_t = Math.abs(parseInt(elem.getAttribute('data-t')));

        let sign = d_t < 0 ? '-' : '+';

        const deadlineString = `${currYear}-${currMonth}-${currDay}T${d_h}:${d_m}:00${sign}${d_t}:00`;
        const deadline = dayjs(deadlineString)

        // CALCULATIONS
        let isAfter = dayjs().isAfter(deadline);

        if (isAfter) {
            // hide element
            elem.style.display = 'none';
        } else {
            // start countdown
            const dispatchInterval = setInterval(() => {
                let diff = deadline.diff(dayjs(), 'second');

                let diff_s = Math.floor(diff % 60);
                let diff_m = Math.floor(diff / 60 % 60);
                let diff_h = Math.floor(diff / 60 / 60 % 60);

                dispatchTimer_hours.innerHTML = diff_h;
                dispatchTimer_mins.innerHTML = diff_m < 10 ? `0${diff_m}` : diff_m;
                dispatchTimer_secs.innerHTML = diff_s < 10 ? `0${diff_s}` : diff_s;

                if (diff < 1) {
                    clearInterval(dispatchInterval);
                    elem.style.display = 'none';
                }
            }, 1000);

            setTimeout(() => {
                elem.style.display = 'block';
            }, 1000)
        }
    }

    for (elem of [...dispatch_countdown_sections]) {
        initSameDayDispatchTimer(elem);
    }

    document.addEventListener('cart:refreshed', () => {
        setTimeout(() => {
            for (elem of [...dispatch_countdown_sections]) {
                initSameDayDispatchTimer(elem);
            }
        }, 1000);
    });


    // FAQ
    const faqNav = document.querySelectorAll('.horizontal-nav button');

    for (var x = 0; x < faqNav.length; x++) {

        faqNav[x].addEventListener('click', function (e) {
            var parent = e.target.dataset.parent;

            // inactive all button
            for (var i = 0; i < faqNav.length; i++) {
                faqNav[i].closest('li').classList.remove('active')
            }

            // active selected
            e.target.closest('li').classList.add('active');

            // inactive all title
            for (var i = 0; i < document.querySelectorAll('.grid-title h2').length; i++) {
                document.querySelectorAll('.grid-title h2')[i].classList.remove('active')
            }

            // active selected title
            document.querySelector('.grid-title h2[data-parent="' + parent + '"]').classList.add('active');

            // close all
            for (var i = 0; i < document.querySelectorAll('.grid-tab_item').length; i++) {
                document.querySelectorAll('.grid-tab_item')[i].classList.remove('open')
            }

            // open selected
            for (var i = 0; i < document.querySelectorAll('.grid-tab_item[data-parent="' + parent + '"]').length; i++) {
                document.querySelectorAll('.grid-tab_item[data-parent="' + parent + '"]')[i].classList.add('open')
            }
        });
    }


    if (faqNav[0]) {
        faqNav[0].click();
    }

    const faqQA = document.querySelectorAll('.grid-tab_item button');

    for (var x = 0; x < faqQA.length; x++) {
        faqQA[x].addEventListener('click', function (e) {
            var parent = e.target.dataset.parent;

            // inactive all button
            // for (var i = 0; i < faqQA.length; i++) {
            //     faqQA[i].closest('.grid-tab_item').classList.remove('active')
            // }

            // active selected
            e.target.closest('.grid-tab_item').classList.toggle('active');
        });
    }

    const selectEl = document.querySelector('.product-text [name="id"]');

    if (selectEl) {
        selectEl.addEventListener('change', function (event) {
            var getVariantId = this.value;

            // for variant meta description
            const variantDescription = document.querySelectorAll('.variant-description');

            if (variantDescription.length > 0) {
                for (var x = 0; x < variantDescription.length; x++) {
                    variantDescription[x].classList.remove('active')
                }

                if (document.querySelector('[data-variant="' + getVariantId + '"]') != null) {
                    document.querySelector('[data-variant="' + getVariantId + '"]').classList.add('active');
                }

                if (document.querySelector('.collapsible-trigger-btn.is-open')) {
                    document.querySelector('.collapsible-trigger-btn.is-open').click();
                }
            }
        });
    }
})

const okendoReviewsHideZeroReviews = () => {
    const reviewsEl = document.querySelectorAll('.product-item__ratings');
    reviewsEl.forEach(el => {
        const reviews = el.querySelector('.oke-sr-count-number')?.innerText;
        if (reviews == "0") {
            el.classList.add('hide-reviews');
        }
    })
}

$(document).on('change', "[name='note']", (e) => updateNotes(e.target.value));

function updateNotes(value) {
    var obj = JSON.stringify({ note: value });
    console.log('updating notes');

    //#! Update attributes
    return fetch('/cart/update.js', {
        method: 'POST',
        body: obj,
        headers: { 'Content-type': 'application/json; charset=UTF-8' },
    });
}

const checkoutBtnOnCartDrawer = document.querySelector('.cart-drawer-checkout-button');
if (checkoutBtnOnCartDrawer) {
    checkoutBtnOnCartDrawer.addEventListener('click', function (event) {
        event.preventDefault();

        const noteEle = document.querySelector("[name='note']");
        if (noteEle) {
            updateNotes(noteEle.value).then(() => {
                window.location.href = '/checkout';
            })
                .catch((error) => {
                    console.error('Error submitting data:', error);
                });
        }
    });
}

// Function prevent to redirect to page cart when clicked clear cart button
$(document).on('click', "#site-cart-sidebar .cart__clear-all > a", clearCart);
async function clearCart(event) {
    event.preventDefault();
    event.target.classList.add('working'); // Add class working to show up loader animation
    const urlClearCart = event.target.href;
    const result = await fetch(urlClearCart)
        .then(res => {
            const cartNotes = document.querySelector("[name='note']");
            cartNotes.value = ""; // Reset cart notes because there is no longer cart items to checkout
            window.refreshCart();
            event.target.classList.remove('working'); // Add class working to show up loader animation
        })
};